import { useNavigate } from 'react-router-dom';

export const useGoBack = (backUrl?: string) => {
	const navigate = useNavigate();

	const goBack = () => {
		if (!backUrl || backUrl === 'goBack') {
			navigate(-1);
			return;
		}
		navigate(backUrl);
	};

	return goBack;
};
